import React, { useEffect, useRef } from "react";
import { languageHelper } from "../../config/helperFunctions";

function Invoice1({ logo, general, data, invoice, handlePrint }) {
  const defaultLang =
    invoice.invoice_lang === "default"
      ? localStorage.getItem("rms-lang") || "text_en"
      : invoice.invoice_lang === "Arabic"
      ? "text_ar"
      : "text_en";
  const date = new Date();
  const invoiceRef = useRef(null);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDate = `${day}-${month}-${year}`;
  let currentDateSlash = `${month}/${day}/${year}`;

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  let currentTime = `${hours}:${minutes}:${seconds}`;

  function formatDate(inputDate) {
    // Split date and time
    const [date] = inputDate.split(" ");
    // Split year, month, and day
    const [year, month, day] = date.split("-");
    // Return formatted date as MM/DD/YYYY
    return `${month}/${day}/${year}`;
  }

  const vatAmount = data.vat_amount - data.tobaco_vat;

  const apiUrl = window.RUNTIME_API_URL;
  const hostname = new URL(apiUrl).hostname;

  const isChangePadding = hostname.includes("sahnew");
  const paddingClass = isChangePadding ? "pr-32" : "pr-8";

  useEffect(() => {
    handlePrint("Default Invoice", invoiceRef);
  }, [handlePrint]);
  return (
    <>
      {/* for sahnew pr-32 */}
      <div
        ref={invoiceRef}
        className={`w-full max-w-5xl mx-auto py-8 pl-8 ${paddingClass}`}
      >
        {/* <div ref={invoiceRef} className="w-full max-w-5xl mx-auto py-8 pl-8 pr-8"> */}
        <img src={logo} className="mx-auto w-32" alt="" />
        <h1 className="text-4xl font-medium text-center mt-6">
          {general.restaurant_name}
        </h1>
        <div className="text-center text-2xl mt-2">
          <p>{general.address}</p>
          <p>
            {languageHelper("Tel", defaultLang)}: {general.phone}
          </p>
          <p>فاتورة ضريبية مبسطة</p>
          <p>({`${currentDate}-${data.token_no}`})</p>
        </div>
        <p className="mt-2 font-bold text-2xl text-center">
          {languageHelper("Tax Registration No", defaultLang)}:{" "}
          {general.tax_reg_no}
        </p>
        <div className="text-center text-2xl mt-2">
          <p>{languageHelper("Welcome", defaultLang)}</p>
          <p>
            {languageHelper("Invoice No", defaultLang)}: {data.sale_no}
          </p>
        </div>
        <div>
          <span className="mx-auto py-1 border-4 text-lg border-black px-2 max-w-64 w-full text-center block">
            {languageHelper("Order", defaultLang)}#: {Number(data.token_no)}
          </span>
          {data.table?.name && (
            <p className="text-lg font-semibold text-center my-2">
              {languageHelper("Table", defaultLang)} # {data.table?.name}
            </p>
          )}
        </div>
        <div className="text-end text-lg mt-16">
          <p>
            {languageHelper("Order Type", defaultLang)}: {data.order_type?.type}
          </p>
          <p>
            {languageHelper("Customer Name", defaultLang)}:{" "}
            {data.is_guest === "no" ? data.customer?.name : data.guest?.name}
          </p>
          {data.order_type_id === 2 && (
            <p>
              {languageHelper("Customer Number", defaultLang)}:{" "}
              {data.is_guest === "no"
                ? data.customer?.phone
                : data.guest?.phone}
            </p>
          )}
          {data.customer.customer_vat && (
            <p>
              {languageHelper("Customer Vat", defaultLang)}:{" "}
              {data.is_guest === "no"
                ? data.customer?.customer_vat
                : data.guest?.customer_vat}
            </p>
          )}
          <p>
            {languageHelper("Cashier Name", defaultLang)}: {data.cashier?.name}
          </p>
        </div>
        <div className="flex justify-between text-xl font-medium mt-4 border-b-2">
          <p className="px-4">
            {languageHelper("Selling Point", defaultLang)}: 1
          </p>
          <p className="px-4">
            {languageHelper("Sales Associate", defaultLang)}:{" "}
            {data.sales_associate || "Admin"}
          </p>
        </div>
        <table className="w-full text-xl">
          <thead className="border-b-2 border-dotted border-black">
            <tr>
              <th className="py-1 whitespace-nowrap text-start">
                {languageHelper("Item", defaultLang)}
              </th>
              <th className="py-1 text-start">
                {languageHelper("Qty", defaultLang)}
              </th>
              <th className="py-1 text-start">
                {languageHelper("Item Price", defaultLang)}
              </th>
              <th className="py-1 text-start">
                {languageHelper("VAT", defaultLang)}
              </th>
              <th className="py-1 text-end">
                {languageHelper("Total", defaultLang)}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.order_details?.map((orderItem, index) => (
              <>
                <tr
                  key={index}
                  className={
                    orderItem.modifiers.length === 0 &&
                    `border-b-2 ${
                      data.order_details.length - 1 === index &&
                      "border-dotted border-black"
                    }`
                  }
                >
                  <td>
                    <p>
                      {invoice.name_lang === "en"
                        ? orderItem.name
                        : invoice.name_lang === "ar"
                        ? orderItem.name_arabic
                        : `${orderItem.name} / ${orderItem.name_arabic}`}
                    </p>
                  </td>
                  <td>{orderItem.qty}</td>
                  <td>{orderItem.menu_unit_price.toFixed(2)}</td>
                  <td>
                    {orderItem.menu_taxes.additional_vat_percentage === 100
                      ? `T - ${orderItem.menu_taxes.additional_vat_percentage}%`
                      : orderItem.menu_taxes.vat_percentage === 15
                      ? `V -  ${orderItem.menu_taxes.vat_percentage}%`
                      : orderItem.menu_taxes.vat_percentage === 0
                      ? `Z - ${orderItem.menu_taxes.vat_percentage}%`
                      : "Exemption"}
                  </td>
                  <td className="text-end">
                    {orderItem.menu_unit_price_with_vat.toFixed(2) ===
                    orderItem.menu_price_with_discount.toFixed(2) ? (
                      <p>
                        {orderItem.menu_unit_price_with_vat.toFixed(2) *
                          orderItem.qty}
                      </p>
                    ) : (
                      <span className="flex gap-2">
                        <p className="line-through">
                          {orderItem.menu_unit_price_with_vat.toFixed(2) *
                            orderItem.qty}
                        </p>
                        <p>
                          {orderItem.menu_price_with_discount.toFixed(2) *
                            orderItem.qty}
                        </p>
                      </span>
                    )}
                  </td>
                </tr>
                {orderItem.food_menu.is_deal === "yes" && (
                  <tr key={index}>
                    <td colSpan={5}>
                      {orderItem.food_menu.deal_details &&
                        JSON.parse(orderItem.food_menu.deal_details)?.map(
                          (deal, index) => (
                            <p key={index}>{`${deal.qty}x ${deal.name}`}</p>
                          )
                        )}
                    </td>
                  </tr>
                )}
                {orderItem.modifiers.map((mod, index) => (
                  <tr
                    key={index}
                    className={
                      orderItem.modifiers.length === index + 1 &&
                      `border-b-2 ${
                        data.order_details.length - 1 === index &&
                        "border-dotted border-black"
                      }`
                    }
                  >
                    <td colSpan={3}>{mod.name}</td>
                    <td className="text-end">{mod.price * orderItem.qty}</td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>

          {/* Summary Rows */}
          <tbody>
            <tr className="font-medium border-b-2">
              <td colSpan={3}>
                <p>Total Inclusive of VAT</p>
                <p>إجمالي شامل لضريبة القيمة المضافة</p>
              </td>
              <td>{data.total_payable.toFixed(2)}</td>
            </tr>
            {data.total_discount_amount !== 0 && (
              <tr className="font-medium border-b-2">
                <td colSpan={3}>
                  {languageHelper("Total Discount", defaultLang)}
                </td>
                <td>{data.total_discount_amount.toFixed(2)}</td>
              </tr>
            )}
            {data.delivery_charges !== 0 && (
              <tr className="font-medium border-b-2">
                <td colSpan={3}>
                  {languageHelper("Service/Delivery", defaultLang)}
                </td>
                <td>{data.delivery_charges.toFixed(2)}</td>
              </tr>
            )}
            <tr className="font-medium border-b-2">
              <td colSpan={3}>{languageHelper("VAT", defaultLang)}</td>
              <td>{vatAmount.toFixed(2)}</td>
            </tr>
            {data.tobaco_vat !== 0 && (
              <tr className="font-medium border-b-2">
                <td colSpan={3}>
                  {languageHelper("Tobacco Tax 100%", defaultLang)}
                </td>
                <td>{data.tobaco_vat}</td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="text-center text-2xl mt-4 space-y-2">
          <p>Prices are VAT Inclusive</p>
          <p>األسعار شاملة ضريبة القيمة المضافة</p>
          <p>Payment Method - طريقة الدفع</p>
        </div>
        <div className="mt-2 font-bold text-2xl mx-auto space-y-2">
          {data.payment.name === "Multi Cash" ? (
            <>
              {data.multiple_payments.map((payments, index) =>
                payments.company_name === "Cash" ? (
                  <React.Fragment key={index}>
                    <span className="flex gap-4 justify-between">
                      <p>{languageHelper("Cash", defaultLang)}</p>
                      <p>{payments.amount.toFixed(2)}</p>
                    </span>
                    <span className="flex gap-4 justify-between">
                      <p>{languageHelper("Total Paid (Cash)", defaultLang)}</p>
                      <p>{payments.amount.toFixed(2)}</p>
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment key={index}>
                    <span className="flex gap-4 justify-between">
                      <p>{languageHelper("Credit Card", defaultLang)}</p>
                      <p>{payments.amount.toFixed(2)}</p>
                    </span>
                    <span className="flex gap-4 justify-between">
                      <p>{languageHelper("Input Method", defaultLang)}</p>
                      <p>{languageHelper("Terminal", defaultLang)}</p>
                    </span>
                    <span className="flex gap-4 justify-between">
                      <p>{languageHelper("Card Company", defaultLang)}</p>
                      <p>{payments.company_name}</p>
                    </span>
                    <span className="flex gap-4 justify-between border-t-2 pt-1">
                      <p>{languageHelper("Certified Amount", defaultLang)}</p>
                      <p>{payments.amount.toFixed(2)}</p>
                    </span>
                  </React.Fragment>
                )
              )}
            </>
          ) : data.payment.name === "Cash" ? (
            <span className="flex gap-4 justify-between">
              <p>{languageHelper("Cash", defaultLang)}</p>
              <p>{data.total_payable.toFixed(2)}</p>
            </span>
          ) : (
            <>
              <span className="flex gap-4 justify-between">
                <p>{languageHelper("Credit Card", defaultLang)}</p>
                <p>{data.total_payable.toFixed(2)}</p>
              </span>
              <span className="flex gap-4 justify-between">
                <p>{languageHelper("Input Method", defaultLang)}</p>
                <p>{languageHelper("Terminal", defaultLang)}</p>
              </span>
              <span className="flex gap-4 justify-between">
                <p>{languageHelper("Card Company", defaultLang)}</p>
                <p>{data.payment.name}</p>
              </span>
              <span className="flex gap-4 justify-between border-t-2 pt-1">
                <p>{languageHelper("Certified Amount", defaultLang)}</p>
                <p>{data.total_payable.toFixed(2)}</p>
              </span>
            </>
          )}

          {/* Always shown */}
          <span className="flex gap-4 justify-between">
            <p>{languageHelper("Received Amount", defaultLang)}</p>
            <p>{(data.received_amount || 0).toFixed(2)}</p>
          </span>
          <span className="flex gap-4 justify-between">
            <p>{languageHelper("Change Amount", defaultLang)}</p>
            <p>
              {(data.change_amount < 0 ? 0 : data.change_amount || 0).toFixed(
                2
              )}
            </p>
          </span>
        </div>

        <div className="text-xl">
          {invoice.order_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>{languageHelper("Order Date", defaultLang)}</p>
              </div>
              <div className="flex space-x-5">
                {" "}
                <p>{formatDate(data.sale_date)}</p>
                <span>{data.order_time}</span>
              </div>
            </div>
          )}
          {invoice.statement_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>{languageHelper("Statement Date", defaultLang)}</p>
              </div>
              <div className="flex space-x-5">
                <p>{formatDate(data.sale_date)}</p>
                <span>{data.order_time}</span>
              </div>
            </div>
          )}
          {invoice.print_date === "yes" && (
            <div className="flex justify-between">
              <div>
                <p>{languageHelper("Print Date", defaultLang)}</p>
              </div>
              <div className="flex space-x-5">
                {" "}
                <p>{currentDateSlash}</p>
                <span>{currentTime}</span>
              </div>
            </div>
          )}
          {/* <span className="flex gap-4 justify-between">
            <p>Order Date</p>
            <p>11/04/2024 9:55:00 PM</p>
          </span>
          <span className="flex gap-4 justify-between">
            <p>Statement Date</p>
            <p>11/04/2024 9:55:00 PM</p>
          </span>
          <span className="flex gap-4 justify-between">
            <p>Print Date</p>
            <p>11/04/2024 9:55:00 PM</p>
          </span> */}
        </div>
        <div>
          <img
            src={data.qr_image_base64 || data.qr_image_url}
            className="w-64 mx-auto mt-4"
            alt=""
          />
          <p className="text-2xl mt-16 text-center font-bold">
            QRالفاتورة االلكترونية
          </p>
        </div>
      </div>
    </>
  );
}

export default Invoice1;
